export default {
  FIRST_NAME: "ZJL490EXAggqZGVmyMZH",
  LAST_NAME: "crDmKYLIeHbcxEZhYQAV",
  PHONE: "DaPn7hvqXFtCNjnpabrq",
  ADDRESSS: "z3OFdCryY8xYDHGZacOx",
  MAKE: "yyTIFlhN1OZY5rM01gvU",
  ZIPCODE: "DAHVADmAqWdtJKOEdWDV",
  CALL_AT: "13ZDUzc89zK7pYka9pMC",
  MAP_LINK: "L6C1UNlbw3YzvQG5cXQm",
  HOW_PAID: "UPoMTHomAe7bcNxDn1wM",
  TOTAL: "Od36bsTxsOGzdPlVFJfu",
  TAX: "uWAaM0zoOp5XnOeaxU9p",
  LANDMARK: "HRgaBu2GIhvzxymznxGs",
  DISPOSITION_CANCEL: "faOdXeHXtOnybv4JzxrA",
  ETA: "3miGYCNydFtsihIJJ25J",
  DISPOSITION_COMPLETE: "EfwdAKRj3y4aKhfyvvBL",
  BALANCE_DUE: "WkcF8SLy43JycFQVUQyX",
  APPOINTMENT_TIME_WINDOW: "appointment_time_window",
  WEEKEND_CHARGES: "0nHHSZcUpFZnJDx6Oy1U",
  WEEKDAY_CHARGES: "eE9WBAvBpDuWAPcdQPEJ",
  YEAR: "TIPRjrjraWHACh99yVH7",
  TAXABLE_AMOUNT: "5QHNz8Te3oNRRGyZvgIE",
  TEMPLATE: "template",
  TECHNICIAN: "technician",
  DISPOSITION: "disposition",
  EMAIL: "epFF5ALhKOFD2neMfBpK",
  REASON_FOR_CANCELLATION: "cKPgubCEbXbKL6Tf3Dif",
  WHAT_IS_TODAY: "R41zaAOEJlRQ3FJ9VOq7",
  TIME_OF_DAY: "gCdVoxJZvheF1a7h1cuc",
  APPLICABLE_ITEM_NUMBERS: "HUDTPhSfgWtb2feCQPmX",
  KEY_CATEGORY: "XzUzyQL7H4dEX3UFQ1iE",
  MODEL: "WhnbOqWgkZddEawgeeEJ",
  TYPE_OF_KEY: "jToR7jtBB4RxCLtxzjsT",
  KEY_CHARGE: "JHsMFKDWFsdqYkd5VZBw",
  LOST_CAR_KEY: "QNNzamkPrP6JXH1gXIhH",
  CAR_UNLOCKING: "roTK3HNhMBtrYUXBAjz7",
  OUTSIDE_TECHNICIAN: "ttGm8A5x7cYkj5ei4rCc",
  TECH_ADDITIONAL_INFORMATION: "6iwySW2LVSNGUlBYGlqx",
  CREDIT_CARD_CONVENIENCE_FEE: "9xrBstydU8SPLTH8ZD0M",
  OUTSIDE_CONTRACTOR: "Outside Contractor",
  AUTOMOTIVE_LOST_KEY: "9o5dLsEfA8gNR8xoafcA",
  MAKE_UNLOCKING: "TrRxubFjSEnja4sajC8N", // production db key for make unlocking
  BIRTH_DATE: "cw5gJ81FWdZdgLofs5aP",
  GOVERMENT_ID: "2I9NEsu2mbmNlOUv2X3v",
  ADDRESSS_KEY: "g6n9yDd5sbXYRdrpO6jm",
  DRIVER_ADDRESS_KEY: "w8qg5PqZLJqoNCKxlqtW",
  BUSINESS_PHONE : "CxRdiNldsQfe8tbZMAbm",
  SECONDARY_NUMBER: '0TJAas67oKlP1Hgr5B7y'
};
